import * as React from "react"

function ClockIcon(props) {
  const color = props.color || "#42405F"

  return (
    <svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 6.5A5.5 5.5 0 016.5 1v0A5.5 5.5 0 0112 6.5v0A5.5 5.5 0 016.5 12v0A5.5 5.5 0 011 6.5v0z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 3.445v3.056l1.833 1.833"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ClockIcon
